let map;

function initMap() {
  map = new google.maps.Map(document.getElementById("storageMap"), {
    center: { lat: window.mapSettings.lat, lng: window.mapSettings.lng },
    zoom: 15,
  });
  window.eqfeed_callback = eqfeed_callback();
}

const eqfeed_callback = function () {
  const latLng = new google.maps.LatLng(window.mapSettings.lat, window.mapSettings.lng);
  new google.maps.Marker({
    position: latLng,
    map: map,
    title: window.mapSettings.name,
  });
};

try {
  window.initMap = initMap();
} catch (error) {
  setTimeout(() => {
    window.initMap = initMap();
  }, 500);
}

$("[ref=phone-number]").on("click", async function () {
  await axios.post("/helper/track/phone/" + $(this).prop("id"));
});

$("[ref=website]").on("click", async function () {
  await axios.post("/helper/track/url/" + $(this).prop("id"));
});
